import { gql } from '@apollo/client';
import { CHECKLIST_IMPLEMENTATIONS } from 'graph/fragments/checklist';

const GET_CHECKLISTS = gql`
  ${CHECKLIST_IMPLEMENTATIONS}

  query Checklists($where: ChecklistsWhereInput) {
    checklists(where: $where) {
      ...ChecklistImplementations
      checklistObservations {
        observation {
          id
          title
          domain {
            id
            title
          }
        }
      }
    }
  }
`;

export default GET_CHECKLISTS;
